import styled, { css } from 'styled-components';
import { NeuCard, NeuTextarea, NeuButton, NeuIcon } from '@neutron/react';

interface ColorProps {
  color?: string;
  cursorType?: boolean;
}
interface DropdownProps {
  showPopover: boolean;
}
interface IModalFooterProps {
  right?: boolean;
}
interface IPopContentProps {
  justify?: string;
}
interface IPopItemProps {
  disabled?: boolean;
}

export const FeedbackCard = styled(NeuCard)`
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f6f6f6 !important;
  z-index: 10;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-inline-end: 0;
  margin-top: 0;
  width: 29em;
`;

export const CardHeader = styled(NeuCard)`
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
  background: white !important;
  height: 56px;
  padding-top: calc(var(--card-spacing) / 2) !important;
  width: 100%;
`;

export const ModalCardContent = styled(NeuCard)`
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.9375rem;
  margin-bottom: 0.5rem;
`;

export const InputHeading = styled.div`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
  margin-top: 0.75rem;
  margin-bottom: 0.4rem;
`;

export const ModalTextArea = styled(NeuTextarea)`
  min-height: 88px;
  margin-bottom: 0.5rem;
`;

export const ModalFooter = styled(NeuCard)<IModalFooterProps>`
  background: white !important;
  bottom: 0;
  height: 69px !important;
  padding-top: var(--card-spacing) !important;
  ${props =>
    !props.right &&
    css`
      display: flex !important;
      justify-content: space-between !important;
    `}
`;

export const StyledDivider = styled.hr`
  width: 98%;
  margin-right: 1.5rem;
`;

export const TitleSpan = styled.span`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 26px;
  color: #06173d;
  width: 280px;
`;

export const TitleSpanView = styled.span`
  display: flex;
  font-size: 16px;
  line-height: 26px;
  color: #06173d;
  width: 280px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const TitleIcon = styled(NeuIcon)`
  margin-right: 8px;
  color: #5d99c8;
`;

export const FeedbackViewDiv = styled.div`
  margin-top: 0.875rem;
`;

export const SearchResultsContainer = styled(FeedbackViewDiv)`
  min-height: 4rem;
`;

export const CompletedTextDiv = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: #000000;
`;

export const FeedbackViewDiv2Column = styled.div`
  display: flex;
  flex-direction: row;
`;

export const LabelHeading = styled.div`
  width: 100%;
  margin-top: 15px;
  font-size: 14px;
  line-height: 22px;
`;

export const LabelContent = styled.div`
  color: #191919;
  font-size: 16px;
  line-height: 26px;
  width: 100%;
`;

export const LabelContentPatient = styled.div<ColorProps>`
  width: 100%;
  margin-top: 5px;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  ${({ cursorType }) =>
    cursorType &&
    css`
      cursor: pointer;
    `}
  color: ${props => props.color}
`;

export const LabelContentBold = styled.div`
  width: 100%;
  margin-top: 5px;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: #191919;
`;

export const FeedbackViewSubDiv = styled.div``;

export const FooterDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DateDiv = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
`;

export const ChipWrapper = styled.span``;

export const UpdatesWrapper = styled.div`
  margin-top: 23px;
`;

export const UpdatesItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 5px;
`;

export const UpdatesIconContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const UpdatesInfoContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0px 10px;
  border-bottom: 1px solid #b0b0b0;
  padding-bottom: 5px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const UpdateTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 26px;
  color: #124e7f;
`;

export const UpdateDate = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 22px;
  color: #686868;
  margin-left: 10px;
`;

export const DetailsContainer = styled.div`
  font-size: 16px;
  line-height: 26px;
  color: #373737;
`;

export const InputContainer = styled.div`
  margin-bottom: 36px;
`;

export const UpdatesTextArea = styled(NeuTextarea)`
  width: 100%;
`;

export const MarkCompleteButton = styled(NeuButton)`
  color: #548a2c !important;
  border-color: #548a2c !important;
`;

export const PopContent = styled.div<IPopContentProps>`
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: var(--primary-60);
`;

export const PopItem = styled.div<IPopItemProps>`
  padding-top: 10px;
  color: var(--primary-60);
  font-weight: bold;
  ${({ disabled }) =>
    disabled
      ? `
  background-color: transparent !important;
  cursor: auto;
  > * {
      color: var(--neu-gray-40) !important;
  }`
      : ''};
`;
